module.exports = __webpack_public_path__ + "img/17_26.0ba1c6ee.png";